import React from 'react';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'mobx-react';
import Dashboard from './components/Dashboard';
import CustomSnackbarProvider from './components/CustomSnackbarProvider';
import { LoadingProvider } from './components/Loading';
import EndingDialog, { EndingDialogProvider } from './components/EndingDialog';
import stores from './stores';
import './utils/i18n';

moment.locale('es');

const theme = createMuiTheme({
  palette: {
    primary: { main: '#e54b4b' },
    secondary: { main: '#72616e' }
  },
  overrides: {},
  typography: {}
});
theme.typography.h5 = {
  fontSize: '1rem',
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem'
  }
};
const App = () => (
  <Router>
    <Provider {...stores}>
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
          <EndingDialogProvider>
            <EndingDialog />
            <LoadingProvider>
              <CustomSnackbarProvider>
                <Dashboard />
              </CustomSnackbarProvider>
            </LoadingProvider>
          </EndingDialogProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </Provider>
  </Router>
);

export default App;
